import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {
  ConfirmRequestDialogAction,
  ConfirmRequestDialogComponent,
  ConfirmRequestDialogComponentData
} from '@shared/component/dialog/confirm-request-dialog/confirm-request-dialog.component';
import {tap} from 'rxjs';

@Directive({
  selector: '[appConfirmRequestDialog]',
  providers: [MatDialogModule]
})
export class ConfirmRequestDialogDirective {
  @Input() useDialog: boolean = true
  @Input() confirmMessage: string;
  @Input() confirmMessageSecond: string;
  @Input() isArlert: boolean;
  @Input() title: string;
  @Output() confirmed: EventEmitter<ConfirmRequestDialogAction> = new EventEmitter<ConfirmRequestDialogAction>();
  @Output() ok: EventEmitter<ConfirmRequestDialogAction.Confirm> = new EventEmitter<ConfirmRequestDialogAction.Confirm>();
  @Output() cancel: EventEmitter<ConfirmRequestDialogAction.Cancel> = new EventEmitter<ConfirmRequestDialogAction.Cancel>();

  constructor(
    protected readonly matDialog: MatDialog
  ) {
  }

  @HostListener('click')
  protected confirm(): void {
    const {title, confirmMessage, confirmMessageSecond, isArlert} = this;

    if (this.useDialog) {
      const dialogRef = ConfirmRequestDialogDirective.openDialog(this.matDialog, {title, confirmMessage, confirmMessageSecond, isArlert});

      dialogRef.afterClosed().pipe(
        tap((action: ConfirmRequestDialogAction | null) => {
          this.handleAction(action)
        })).subscribe();
    } else {
      this.handleAction(ConfirmRequestDialogAction.Confirm)
    }
  }

  handleAction(action: ConfirmRequestDialogAction | null) {
    const finalAction = action ? action : ConfirmRequestDialogAction.Cancel

    this.confirmed.emit(finalAction);

    switch (finalAction) {
      case ConfirmRequestDialogAction.Confirm: {
        this.ok.emit(ConfirmRequestDialogAction.Confirm)
        break;
      }
      case ConfirmRequestDialogAction.Cancel: {
        this.cancel.emit(ConfirmRequestDialogAction.Cancel)
        break;
      }
      default: {
      }
    }
  }

  static openDialog(dialog: MatDialog, data: ConfirmRequestDialogComponentData) {
    return dialog.open<ConfirmRequestDialogComponent, ConfirmRequestDialogComponentData,
     ConfirmRequestDialogAction>(ConfirmRequestDialogComponent, {
      minWidth: '30%',
      maxWidth: '40%',
      autoFocus: false,
      data
    })
  }
}
